<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import Cookies from 'js-cookie'
import Modal from '../components/Modal.vue'

/**
 * Shows an intro modal to users when they open the site for the first time.
 * Uses a cookie to track if the user has seen the intro before.
 */

const introModal = ref(null)
const cookieName = 'intro_shown'

const showIfNoCookie = () => {
    const shown = Cookies.get(cookieName)
    if (!shown) {
        nextTick(() => {
            introModal.value?.show()
            Cookies.set(cookieName, 'true', { expires: 365 })
        })
    }
}

onMounted(() => {
    window.addEventListener('load', showIfNoCookie)
})

onUnmounted(() => {
    window.removeEventListener('load', showIfNoCookie)
})
</script>

<template>
    <Modal ref="introModal" id="vue-intro-modal" title="Welcome to The Button">
        <div class="c-modal__intro-content">
            <p>
                The button is a free game where you can press a button to reset
                a timer.
            </p>
            <p>
                The timer counts up from zero, and every time someone presses
                it, it resets back to zero again.
            </p>
            <p>
                Your goal is to press the button when the timer is as high as
                possible, earning you points and climbing the leaderboard.
            </p>
            <p>
                Waiting for a higher tier can risk someone else beating you to
                it. The timer is the same for everyone, and resets for everyone
                when one person presses it!
            </p>
        </div>

        <button
            type="button"
            class="c-modal__actions c-button"
            data-a11y-dialog-hide
            aria-label="Close dialog"
        >
            Let's do it!
        </button>
    </Modal>
</template>
